<template>
  <div>
    <v-btn @click="showAddModal" class="pr-0" small color="primary">
      <v-icon>add</v-icon><span>追加</span>
      <v-menu
        :close-on-content-click="false"
        :offset-y="true"
        nudge-left="66"
        bottom
        right
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            @click="$event.stopPropagation()"
            icon
            class="mr-0"
            ><v-icon>mdi-menu-down</v-icon></v-btn
          >
        </template>

        <v-card>
          <v-list>
            <v-list-tile @click="showGroupBulkModal">
              <v-list-tile-content>
                <v-list-tile-title>
                  グループ一括登録
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-list>
            <v-list-tile @click="showGroupAndLocationBulkModal">
              <v-list-tile-content>
                <v-list-tile-title>
                  グループ・地点一括登録
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'AppDropDownButton',
  props: {
    showAddModal: {
      type: Function,
      default: () => {},
    },
    showGroupBulkModal: {
      type: Function,
      default: () => {},
    },
    showGroupAndLocationBulkModal: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
// vuetify override
.v-list {
  padding: 0;
}
</style>
